/**
 * @generated SignedSource<<958fb5adbccc1c73817035c31c0d22af>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type useViewedComments_write$data = {
  readonly commentIds: ReadonlyArray<string | null>;
  readonly " $fragmentType": "useViewedComments_write";
};
export type useViewedComments_write$key = {
  readonly " $data"?: useViewedComments_write$data;
  readonly " $fragmentSpreads": FragmentRefs<"useViewedComments_write">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "useViewedComments_write",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "commentIds"
    }
  ],
  "type": "ViewedComments"
};

(node as any).hash = "d155cf7774eeec1efd57aa640539aef9";

export default node;
